import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import DateField from '../../../FormLegacy/FormFieldsV2/DateField'

import Note from './Note'

export const DailyForm = ({ values, setFieldValue }) => {
  const { t } = useTranslation(['visitors'])
  return (
    <div className="visitor-wrapper">
      <div>
        <div className="columns visitorMarginTop">
          <div className="column is-6">
            <div className="input-container">
              <p className="input-label">{t('visitors:form.startTimeLabel')}</p>
              <DateField
                name="timeStart"
                values={values.timeStart}
                selected={values.timeStart}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={t('visitors:form.timeCaption')}
                dateFormat="h:mm aa"
                onChange={(time) => {
                  setFieldValue('timeStart', time.target.value)
                }}
                placeholderText={t('visitors:form.selectTime')}
              />
            </div>
          </div>
          <div className="column is-6">
            <div className="input-container">
              <p className="input-label">{t('visitors:form.endTimeLabel')}</p>
              <DateField
                name="timeEnd"
                values={values.timeEnd}
                selected={values.timeEnd}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={t('visitors:form.timeCaption')}
                dateFormat="h:mm aa"
                onChange={(time) => {
                  setFieldValue('timeEnd', time.target.value)
                }}
                placeholderText={t('visitors:form.selectTime')}
              />
            </div>
          </div>
        </div>
        <Note values={values} setFieldValue={setFieldValue} />
      </div>
    </div>
  )
}

DailyForm.propTypes = {
  values: PropTypes.shape({
    timeStart: PropTypes.instanceOf(Date),
    timeEnd: PropTypes.instanceOf(Date),
    isVisitorNoteOpen: PropTypes.bool,
    visitorNote: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default DailyForm
